import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import { Dialog, DialogContent } from "@/components/Dialog/Dialog";
import { Drawer, DrawerContent } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import HowToFinanceContent from "@/pages/checkout/pre-checkout/how-to-finance/HowToFinanceContent";
var FinanceModal = function FinanceModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    isNew = _ref.isNew,
    postId = _ref.postId,
    financeSteps = _ref.financeSteps,
    g4Data = _ref.g4Data;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;

  // Lock body scroll when drawer is open
  useEffect(function () {
    if (isOpen && isMobile) {
      document.body.style.overflow = "hidden";
      return function () {
        document.body.style.overflow = "";
      };
    }
  }, [isOpen, isMobile]);
  var content = /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 flex items-center justify-between p-4 py-3 border-b border-solid border-gray-200"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-bold text-black-primary"
  }, tShort('pre-checkout/requirements_title', {
    ns: 'web_post_view'
  })), /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClose,
    className: "bg-transparent border-none cursor-pointer",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0 overflow-y-auto"
  }, /*#__PURE__*/React.createElement(HowToFinanceContent, {
    isNew: isNew,
    financeSteps: financeSteps,
    showFinanceSteps: true,
    postId: postId,
    g4Data: g4Data
  })));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Drawer, {
      open: isOpen,
      onOpenChange: function onOpenChange(open) {
        return !open && onClose();
      },
      snapPoints: [1],
      fadeFromIndex: 0,
      modal: false,
      handleOnly: true
    }, /*#__PURE__*/React.createElement(DrawerContent, {
      className: "bg-white flex flex-col rounded-t-[16px] !max-h-full h-full fixed bottom-0 left-0 right-0 z-[99999] !mt-0"
    }, content));
  }
  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-[700px] w-[90vw] h-[90vh] p-0 overflow-hidden flex flex-col",
    haveClose: false,
    overlayClassName: "z-[9999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 flex items-center justify-between p-4 py-3 border-b border-solid border-gray-200"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-bold text-black-primary"
  }, tShort('pre-checkout/requirements_title', {
    ns: 'web_post_view'
  })), /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClose,
    className: "bg-transparent border-none cursor-pointer",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0 overflow-y-auto"
  }, /*#__PURE__*/React.createElement(HowToFinanceContent, {
    isNew: isNew,
    financeSteps: financeSteps,
    showFinanceSteps: true,
    postId: postId,
    g4Data: g4Data
  }))));
};
export default FinanceModal;